__turbopack_context__.v({
  "active": "productGallery-module-scss-module__D7fGba__active",
  "default": "productGallery-module-scss-module__D7fGba__default",
  "imageWrapper": "productGallery-module-scss-module__D7fGba__imageWrapper",
  "mainImage": "productGallery-module-scss-module__D7fGba__mainImage",
  "productGalleryWrapper": "productGallery-module-scss-module__D7fGba__productGalleryWrapper",
  "thumbnails": "productGallery-module-scss-module__D7fGba__thumbnails",
});
